export enum AccordionSize {
  XS = 'xs',
  SM = 'sm',
  RG = 'rg',
  MD = 'md',
  LG = 'lg',
  XL = 'xl'
}

export enum AccordionType {
  Card = 'card',
  List = 'list',
}

export const AccordionContentTop = 16;
